import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { CleanIcon, DeleteIcon, EditIcon, DownloadIcon, CheckIcon, ExisIcon } from 'assets/icons';
import { Table, Pagination, DatePicker, Tooltip, Input, Select, Modal, Button } from 'components';
import { AdvertisementService } from 'services';
import moment from 'moment';
import { Globals, Constants, checkPermission } from 'utils';
import ModalEdit from './modal-edit';

const INITIAL_STATE = {
	since: '',
	until: '',
	search: '',
	status: '',
	valid: '',
	advertising_rate_id: '',
	type: Constants.ADVERTISEMENTS.TYPE.CLASSIFIED,
	level_id: '',
};

const LEVELS_OPTIONS = [
	{ value: '', label: 'Todos' },
	{ value: Constants.LEVELS.AFFILIATE, label: 'Afiliado' },
	{ value: Constants.LEVELS.SELLER, label: 'Vendedor' },
	{ value: Constants.LEVELS.USER, label: 'Usuario' },
];

class Classified extends React.Component<any> {

	timer: any = undefined;

	state = {
		data: [],
		page: 1,
		last_page: 1,
		// --- ESTADO PARA EL MODAL ---
		showDetailModal: false,
		selectedAd: null as any,

		header: [
			'Fecha de solicitud',
			'Nombre',
			'Tipo de Usuario',
			'CI/RIF',
			'Publicidad clasificada',
			'Tiempo contratado',
			'Fecha de aprobación',
			'Estatus',
			'Vigencia',
			'Acciones'
		],
		form: { ...INITIAL_STATE },
		showImagePreview: false,
		showEditModal: false,
		selectedEditItem: null as any,
	};

	componentDidMount() {
		this.load();
	}

	// --- LÓGICA ORIGINAL DE CARGA (PRESERVADA) ---
	load = async (withoutLoading: boolean = false) => {
		const res: any = await AdvertisementService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD'),
		});
		this.setState({
			data: res.advertisements.rows,
			last_page: res.advertisements.count,
		});
	};

	// --- LÓGICA ORIGINAL DE IMPRESIÓN (PRESERVADA) ---
	print = async () => {
		const res: any = await AdvertisementService.admin.get({
			...this.state.form,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD'),
			download: true,
		});

		if (res.url) {
			const link = document.createElement('a');
			link.href = res.url;
			link.download = res.url.split('/').pop();
			link.target = '_blank';
			link.click();
			link.remove();
		}
	}

	change = (e: any, callback: any = null) => {
		const { name, value } = e.target;
		this.setState(
			{
				form: {
					...this.state.form,
					[name]: value,
				},
			},
			callback
		);
	};

	applyFilters = () => {
		this.setState(
			{
				page: 1,
			},
			() => this.load(true),
		);
	};

	reset = () => {
		this.setState(
			{
				form: { ...INITIAL_STATE },
			},
			() => this.load(true)
		);
	};

	// --- ACCIONES DE GESTIÓN ---
	approve = async (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm('¿Desea aprobar el clasificado?', async () => {
			await AdvertisementService.admin.approve({ id: item.id, reject: null });
			this.load(true);
		});
	};

	reject = async (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm('¿Desea rechazar el clasificado?', async () => {
			await AdvertisementService.admin.approve({ id: item.id, reject: true });
			this.load(true);
		});
	};

	delete = async (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm('¿Desea eliminar el clasificado?', async () => {
			await AdvertisementService.admin.delete({
				id: item.id,
			});
			this.load(true);
		});
	};

	edit = async (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			showEditModal: true,
			selectedEditItem: item
		});
	};

	closeEditModal = () => {
		this.setState({
			showEditModal: false,
			selectedEditItem: null
		});
	};

	openDetailModal = (item: any) => {
		console.log('item', item);
		this.setState({
			selectedAd: item,
			showDetailModal: true
		});
	};

	closeDetailModal = () => {
		this.setState({
			showDetailModal: false,
			selectedAd: null
		});
	};

	getContactMehtods = (selectedAd: any) => {
		const adContactMethods = selectedAd?.contact_methods_txt;

		const userContactMethods = selectedAd?.user?.consultation?.contact_methods_txt;

		// Evaluamos si el anuncio tiene métodos válidos (es un array Y no está vacío)
		const hasAdMethods = Array.isArray(adContactMethods) && adContactMethods.length > 0;

		// Priorizamos: Si el anuncio tiene métodos, los usamos; si no, caemos al usuario
		const contactMethods = hasAdMethods ? adContactMethods : userContactMethods;

		const formattedMethods = Array.isArray(contactMethods) && contactMethods.length > 0
			? contactMethods.join(', ')
			: 'No especificado';

		return formattedMethods;
	}

	renderDetailModal = () => {
		const { showDetailModal, selectedAd, showImagePreview } = this.state;

		if (!showDetailModal || !selectedAd) return null;

		const detail = selectedAd.details?.[0] || {};
		const user = selectedAd.user || {};
		const levelName = user.level?.name || 'Usuario';

		// Determinar métodos de contacto a mostrar (priorizando los del anuncio (si los selecciono), luego los del usuario)
		const formattedMethods = this.getContactMehtods(selectedAd);

		const documentUrl = detail.document
			? `${Constants.BASE_PUBLIC || ''}/storage/${detail.document}`
			: null;

		const styles: { [key: string]: React.CSSProperties } = {
			modalTitle: {
				fontSize: '1.25rem',
				fontWeight: 800,
				color: '#000',
				marginBottom: '4px'
			},
			userInfo: {
				fontSize: '0.95rem',
				color: '#7CB342', // Verde oliva del mockup
				fontWeight: 600,
				marginBottom: '20px'
			},
			sectionLabel: {
				fontSize: '0.75rem',
				fontWeight: 700,
				color: '#000',
				marginBottom: '4px'
			},
			adTitle: {
				fontSize: '1.1rem',
				fontWeight: 500,
				color: '#444',
				lineHeight: '1.2'
			},
			priceTag: {
				fontSize: '1.5rem',
				fontWeight: 800,
				color: '#000',
				textAlign: 'right'
			},
			contentBody: {
				fontSize: '0.9rem',
				color: '#555',
				lineHeight: '1.5',
				textAlign: 'justify',
				marginBottom: '20px'
			},
			bigNumber: {
				fontSize: '1.8rem',
				fontWeight: 700,
				color: '#333',
				lineHeight: '1'
			},
			documentCard: {
				backgroundColor: '#dcedc8',
				borderRadius: '12px',
				padding: '8px 12px',
				display: 'flex',
				alignItems: 'center',
				gap: '10px',
				maxWidth: '100%',
				border: '1px solid #c5e1a5'
			},
			actionButton: {
				backgroundColor: '#dcedc8',
				color: '#33691e',
				border: 'none',
				borderRadius: '12px',
				padding: '12px 20px',
				fontWeight: 600,
				fontSize: '0.9rem',
				display: 'flex',
				alignItems: 'center',
				gap: '8px',
				flex: 1,
				justifyContent: 'center',
				cursor: 'pointer'
			},
			// Estilos para el visor de imagen (Lightbox)
			lightboxOverlay: {
				position: 'fixed',
				top: 0,
				left: 0,
				width: '100vw',
				height: '100vh',
				backgroundColor: 'rgba(0, 0, 0, 0.85)',
				zIndex: 9999, // Superponer a todo
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				cursor: 'zoom-out'
			},
			closeButton: {
				position: 'absolute',
				top: -40,
				right: 0,
				background: 'transparent',
				border: 'none',
				color: '#fff',
				fontSize: '2rem',
				cursor: 'pointer'
			}
		};

		return (
			<>
				{/* --- MODAL PRINCIPAL --- */}
				<Modal
					className="modal-view-payment"
					visible={showDetailModal}
					onClose={this.closeDetailModal}
					title="Detalle"
					size="md"
				>
					<div className="container-fluid py-2">

						{/* 1. HEADER: Título General + Usuario */}
						<div className="mb-3">
							<h2 style={styles.modalTitle}>Publicidad clasificada</h2>
							<div style={styles.userInfo}>
								{user.name} - <span>{levelName}</span>
							</div>
						</div>

						{/* 2. TÍTULO DEL CLASIFICADO Y PRECIO */}
						<div className="d-flex justify-content-between align-items-start mb-3">
							<div style={{ paddingRight: '15px', flex: 1 }}>
								<div style={styles.sectionLabel}>Título de clasificado</div>
								<div style={styles.adTitle}>{detail.title || 'Sin Título'}</div>
							</div>
							<div style={styles.priceTag}>
								${selectedAd.total_amount || '0.00'}
							</div>
						</div>

						{/* 3. CONTENIDO / DESCRIPCIÓN */}
						<div className="mb-4">
							<div style={styles.sectionLabel}>Contenido anuncio</div>
							<div style={styles.contentBody}>
								{detail.content || 'Sin descripción disponible.'}
							</div>
						</div>

						{/* 4. GRID: TIEMPO Y CÉDULA (DOCUMENTO) */}
						<div className="row mb-4">
							{/* Columna Tiempo */}
							<div className="col-5">
								<div style={styles.sectionLabel}>Tiempo a contratar (días)</div>
								<div style={styles.bigNumber}>{selectedAd.days}</div>
							</div>

							{/* Columna Cédula (Documento) */}
							<div className="col-7">
								<div style={styles.sectionLabel}>Cédula de identidad</div>
								{documentUrl ? (
									<div
										// Evento para abrir el Lightbox
										onClick={() => this.setState({ showImagePreview: true })}
										style={{
											...styles.documentCard,
											cursor: 'pointer',
											transition: 'transform 0.2s',
										}}
										onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
										onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
									>
										<div style={{
											width: '40px', height: '40px',
											borderRadius: '8px', overflow: 'hidden',
											flexShrink: 0, backgroundColor: '#fff'
										}}>
											<img
												src={documentUrl}
												alt="Doc"
												style={{ width: '100%', height: '100%', objectFit: 'cover' }}
											/>
										</div>
										<div style={{ fontSize: '0.85rem', fontWeight: 600, color: '#33691e', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
											Ver Documento <i className="fas fa-search-plus ml-1"></i>
										</div>
									</div>
								) : (
									<span className="text-muted small">No adjunto</span>
								)}
							</div>
						</div>

						{/* 5. MÉTODOS DE CONTACTO (Botones) */}
						<div>
							<div style={styles.sectionLabel} className="mb-2">Método de contacto</div>
							<div className="d-flex gap-3" style={{ gap: '15px' }}>
								<button style={styles.actionButton}>
									<i className="fas fa-video"></i> {formattedMethods}
								</button>
							</div>
						</div>

					</div>

					{/* Footer Minimalista */}
					<div className="modal-footer border-0 pt-0">
						<button type="button" className="btn btn-link text-muted" onClick={this.closeDetailModal}>
							Cerrar
						</button>
					</div>
				</Modal>

				{/* --- COMPONENTE VISOR DE IMAGEN (LIGHTBOX) --- */}
				{showImagePreview && documentUrl && (
					<div
						style={styles.lightboxOverlay}
						// Al hacer click en el fondo negro, se cierra
						onClick={() => this.setState({ showImagePreview: false })}
					>
						<div style={{ position: 'relative', maxWidth: '90%', maxHeight: '90%' }}>
							{/* Botón X de cerrar */}
							<button
								onClick={() => this.setState({ showImagePreview: false })}
								style={styles.closeButton}
							>
								&times;
							</button>

							{/* Imagen Expandida */}
							<img
								src={documentUrl}
								alt="Documento Expandido"
								style={{
									maxWidth: '100%',
									maxHeight: '90vh',
									borderRadius: '8px',
									boxShadow: '0 10px 30px rgba(0,0,0,0.5)',
									cursor: 'default'
								}}
								// Evitamos que el click en la imagen misma cierre el visor
								onClick={(e) => e.stopPropagation()}
							/>
						</div>
					</div>
				)}
			</>
		);
	};

	canReset = () => {
		return JSON.stringify(this.state.form) !== JSON.stringify(INITIAL_STATE);
	};
	render() {
		return (
			<div className="main-content">
				{this.renderDetailModal()}
				{this.state.showEditModal && (
					<ModalEdit
						item={this.state.selectedEditItem}
						onClose={this.closeEditModal}
						onSuccess={() => {
							this.closeEditModal();
							this.load(true);
						}}
					/>
				)}
				<div className="row row-filter d-flex flex-wrap align-items-end">
					{/* --- FILTROS --- */}
					<div className="col-md-2">
						<Input
							value={this.state.form.search}
							name="search"
							label="Buscar por nombre o CI/RIF"
							placeholder="Buscar"
							className="input-table"
							onChange={this.change}
						/>
					</div>

					<div className="col-md-2">
						<Select
							label="Estatus"
							name="status"
							className="input-table w-100"
							onChange={this.change}
							value={this.state.form.status}
							options={[
								{ value: '', label: 'Todos' },
								{ value: '0', label: 'Pendientes' },
								{ value: '1', label: 'Aprobados' },
								{ value: '2', label: 'Rechazados' },
							]}
						/>
					</div>

					<div className="col-md-2">
						<Select
							label="Vigencia"
							name="valid"
							className="input-table w-100"
							onChange={this.change}
							value={this.state.form.valid}
							options={[
								{ value: '', label: 'Todas' },
								{ value: 'Vigente', label: 'Vigente' },
								{ value: 'Vencido', label: 'Vencido' },
							]}
						/>
					</div>

					<div className="col-md-2">
						<Select
							label="Tipo de usuario"
							name="level_id"
							className="input-table w-100"
							onChange={this.change}
							value={this.state.form.level_id}
							options={LEVELS_OPTIONS.map(level => ({
								value: level.value.toString(),
								label: level.label,
							}))}
						/>
					</div>

					<div className="col-md-2">
						<DatePicker
							placeholder="Desde"
							className="w-100"
							onChange={(text: string) => {
								this.change({ target: { value: text, name: 'since' } });
							}}
							value={this.state.form.since}
						/>
					</div>

					<div className="col-md-2">
						<DatePicker
							placeholder="Hasta"
							className="w-100"
							onChange={(text: string) => {
								this.change({ target: { value: text, name: 'until' } });
							}}
							value={this.state.form.until}
						/>
					</div>

					{this.props.advertising_rates && (
						<div className="col-md-2">
							<Select
								label="Tarifa de publicidad"
								name="advertising_rate_id"
								className="input-table w-100"
								onChange={(e: any) => this.change(e, () => { this.load(true); })}
								value={this.state.form.advertising_rate_id}
								options={[
									{ value: '', label: 'Todas' },
									...this.props.advertising_rates.map((rate: any) => ({
										value: rate.id.toString(),
										label: rate.name,
									})),
								]}
							/>
						</div>
					)}

					<div className="col-md-2 filter-actions">
						<Button className="btn-filter" onClick={this.applyFilters}>
							Filtrar
						</Button>
						{this.canReset() && (
							<button className="btn btn-clean" onClick={this.reset}>
								<img src={CleanIcon} alt="Limpiar filtros" />
							</button>
						)}
					</div>
				</div>

				{this.props.tabs}

				<Table
					title="Registro de clasificados"
					data={this.state.data.length}
					rightAlign={[9]}
					titleRight={
						<Button className="btn-download" onClick={() => this.print()}>
							<img src={DownloadIcon} alt="Descargar Excel" />
							<span>Descargar Excel</span>
						</Button>
					}
					header={this.state.header}
				>
					{this.state.data.map((i: any, index: number) => {
						const detail = i.details && i.details.length > 0 ? i.details[0] : {};

						return (
							<tr key={index}>
								<td>{moment(i.created_at).format('DD-MM-YYYY')}</td>
								<td>{i.user?.name || ''}</td>
								<td>{i.user?.level?.name || ''}</td>
								<td>
									{i.user?.document_type?.name} {i.user?.document}
								</td>

								{/* --- COLUMNA MODIFICADA: Título + Botón Ver --- */}
								<td>
									<div className="d-flex flex-column">
										<a
											href="#"
											className="font-weight-bold text-primary mt-1"
											style={{ textDecoration: 'none', fontSize: '0.85rem' }}
											onClick={(e) => {
												e.preventDefault();
												this.openDetailModal(i);
											}}
										>
											Ver
										</a>
									</div>
								</td>

								<td>{i.days} días</td>
								<td>{i.approval_date ? moment(i.approval_date).format('DD-MM-YYYY') : '-'}</td>
								<td>{i.status_txt}</td>
								<td>{i.valid_txt}</td>
								<td className="actions">
									{checkPermission(Constants.MODULES.REGISTER, 'write', this.props.user) && (
										<Tooltip title="Editar">
											<a className="link-icon" href="#" onClick={(e: any) => this.edit(e, i)}>
												<img src={EditIcon} alt="Editar" />
											</a>
										</Tooltip>
									)}
									{checkPermission(Constants.MODULES.REGISTER, 'delete', this.props.user) && (
										<Tooltip title="Eliminar">
											<a className="link-icon" href="#" onClick={(e: any) => this.delete(e, i)}>
												<img src={DeleteIcon} alt="Eliminar" />
											</a>
										</Tooltip>
									)}
									{checkPermission(Constants.MODULES.REGISTER, 'write', this.props.user) &&
										i.status === Constants.USER_STATUS.INACTIVE && (
											<>
												<Tooltip title="Aprobar">
													<a className="link-icon" href="#" onClick={(e: any) => this.approve(e, i)}>
														<img src={CheckIcon} alt="Aprobar" />
													</a>
												</Tooltip>
												<Tooltip title="Rechazar">
													<a className="link-icon" href="#" onClick={(e: any) => this.reject(e, i)}>
														<img src={ExisIcon} alt="Rechazar" />
													</a>
												</Tooltip>
											</>
										)}
								</td>
							</tr>
						);
					})}
				</Table>

				<Pagination
					pages={this.state.last_page}
					active={this.state.page}
					onChange={async (page: number) => {
						await this.setState({ page });
						this.load();
					}}
				/>
			</div>
		);
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user,
	};
})(Classified);